export {
  FinanceRepresentativeExample,
  type FinanceFigures as NewCarsFinanceFigures,
} from './finance-representative-example'
